import { render, staticRenderFns } from "./BillingTypeEdit.vue?vue&type=template&id=2d9c45ea&lang=pug"
import script from "./BillingTypeEdit.vue?vue&type=script&lang=js"
export * from "./BillingTypeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports